import type { Profile } from '@/types';
import type { AppState } from './types';

export function updateActiveProfile(
    state: AppState,
    updates: Partial<Profile>
): Partial<AppState> {
    if (!state.activeProfileId) return {};

    const profiles = state.profiles.map(p =>
        p.id === state.activeProfileId
            ? { ...p, ...updates }
            : p
    );

    return { profiles } as Partial<AppState>;
}
